import React, { useState, useEffect } from "react";
import "./Gallery.css";
import { Link } from "react-router-dom";

function Gallery() {
	useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [activeSection, setActiveSection] = useState("SHOWER DOORS");

  const handleSectionClick = (section) => {
    setActiveSection(section);
  };

  return (
    <section className="gallery">
      <div className="gallery__preview">
        <h1 className="gallery__title">GALLERY</h1>
        <h2 className="gallery__subtitle">MIKDASH DEVELOPMENT</h2>
      </div>
      <div className="gallery__bar">
        <span
          className={`gallery__bar-button ${
            activeSection === "SHOWER DOORS" ? "active" : ""
          }`}
          onClick={() => handleSectionClick("SHOWER DOORS")}
        >
          SHOWER DOORS
        </span>
        <span
          className={`gallery__bar-button ${
            activeSection === "CABINET KITCHEN" ? "active" : ""
          }`}
          onClick={() => handleSectionClick("CABINET KITCHEN")}
        >
          CABINET KITCHEN
        </span>
        <span
          className={`gallery__bar-button ${
            activeSection === "FLOOR TILES" ? "active" : ""
          }`}
          onClick={() => handleSectionClick("FLOOR TILES")}
        >
          FLOOR TILES
        </span>
        <span
          className={`gallery__bar-button ${
            activeSection === "WALL TILES" ? "active" : ""
          }`}
          onClick={() => handleSectionClick("WALL TILES")}
        >
          WALL TILES
        </span>
        <span
          className={`gallery__bar-button ${
            activeSection === "VINYL&LAMINATE" ? "active" : ""
          }`}
          onClick={() => handleSectionClick("VINYL&LAMINATE")}
        >
          VINYL&LAMINATE
        </span>
        <span
          className={`gallery__bar-button ${
            activeSection === "FLOORING" ? "active" : ""
          }`}
          onClick={() => handleSectionClick("FLOORING")}
        >
          FLOORING
        </span>
        <span
          className={`gallery__bar-button ${
            activeSection === "SINKS" ? "active" : ""
          }`}
          onClick={() => handleSectionClick("SINKS")}
        >
          SINKS
        </span>
        <span
          className={`gallery__bar-button ${
            activeSection === "BATHROOMS" ? "active" : ""
          }`}
          onClick={() => handleSectionClick("BATHROOMS")}
        >
          BATHROOMS
        </span>
      </div>
			{activeSection === "SHOWER DOORS" && (
      <div className="gallery__container">
        <div className="gallery__card shower-doors1" />
        <div className="gallery__card shower-doors2" />
        <div className="gallery__card shower-doors3" />
        <div className="gallery__card shower-doors4" />
        <div className="gallery__card shower-doors5" />
        <div className="gallery__card shower-doors6" />
        <div className="gallery__card shower-doors7" />
        <div className="gallery__card shower-doors8" />
      </div>
			)}
			{activeSection === "CABINET KITCHEN" && (
      <div className="gallery__container">
        <div className="gallery__card cabinet-kitchen1" />
        <div className="gallery__card cabinet-kitchen2" />
        <div className="gallery__card cabinet-kitchen3" />
        <div className="gallery__card cabinet-kitchen4" />
        <div className="gallery__card cabinet-kitchen5" />
        <div className="gallery__card cabinet-kitchen6" />
        <div className="gallery__card cabinet-kitchen7" />
        <div className="gallery__card cabinet-kitchen8" />
        <div className="gallery__card cabinet-kitchen9" />
        <div className="gallery__card cabinet-kitchen10" />
        <div className="gallery__card cabinet-kitchen11" />
        <div className="gallery__card cabinet-kitchen12" />
        <div className="gallery__card cabinet-kitchen13" />
        <div className="gallery__card cabinet-kitchen14" />
        <div className="gallery__card cabinet-kitchen15" />
        <div className="gallery__card cabinet-kitchen16" />
        <div className="gallery__card cabinet-kitchen17" />
        <div className="gallery__card cabinet-kitchen18" />
      </div>
			)}
				{activeSection === "FLOOR TILES" && (
      <div className="gallery__container">
        <div className="gallery__card floor-tiles1" />
        <div className="gallery__card floor-tiles2" />
        <div className="gallery__card floor-tiles3" />
        <div className="gallery__card floor-tiles4" />
        <div className="gallery__card floor-tiles5" />
        <div className="gallery__card floor-tiles6" />
        <div className="gallery__card floor-tiles7" />
        <div className="gallery__card floor-tiles8" />
      </div>
				)}
				{activeSection === "WALL TILES" && (
      <div className="gallery__container">
        <div className="gallery__card wall-tiles1" />
        <div className="gallery__card wall-tiles2" />
        <div className="gallery__card wall-tiles3" />
        <div className="gallery__card wall-tiles4" />
        <div className="gallery__card wall-tiles5" />
        <div className="gallery__card wall-tiles6" />
        <div className="gallery__card wall-tiles7" />
        <div className="gallery__card wall-tiles8" />
      </div>
				)}
				{activeSection === "VINYL&LAMINATE" && (
      <div className="gallery__container">
        <div className="gallery__card vinyl-laminate1" />
        <div className="gallery__card vinyl-laminate2" />
        <div className="gallery__card vinyl-laminate3" />
        <div className="gallery__card vinyl-laminate4" />
        <div className="gallery__card vinyl-laminate5" />
        <div className="gallery__card vinyl-laminate6" />
        <div className="gallery__card vinyl-laminate7" />
        <div className="gallery__card vinyl-laminate8" />
      </div>
				)}
				{activeSection === "FLOORING" && (
      <div className="gallery__container">
        <div className="gallery__card flooring1" />
        <div className="gallery__card flooring2" />
        <div className="gallery__card flooring3" />
        <div className="gallery__card flooring4" />
        <div className="gallery__card flooring5" />
        <div className="gallery__card flooring6" />
        <div className="gallery__card flooring7" />
        <div className="gallery__card flooring8" />
        <div className="gallery__card flooring9" />
        <div className="gallery__card flooring10" />
        <div className="gallery__card flooring11" />
        <div className="gallery__card flooring12" />
        <div className="gallery__card flooring13" />
        <div className="gallery__card flooring14" />
        <div className="gallery__card flooring15" />
        <div className="gallery__card flooring16" />
      </div>
				)}
				{activeSection === "SINKS" && (
      <div className="gallery__container">
        <div className="gallery__card skins1" />
        <div className="gallery__card skins2" />
        <div className="gallery__card skins3" />
        <div className="gallery__card skins4" />
        <div className="gallery__card skins5" />
        <div className="gallery__card skins6" />
        <div className="gallery__card skins7" />
        <div className="gallery__card skins8" />
        <div className="gallery__card skins9" />
        <div className="gallery__card skins10" />
        <div className="gallery__card skins11" />
        <div className="gallery__card skins12" />
        <div className="gallery__card skins13" />
        <div className="gallery__card skins14" />
      </div>
				)}
				{activeSection === "BATHROOMS" && (
      <div className="gallery__container">
        <div className="gallery__card bathrooms1" />
        <div className="gallery__card bathrooms2" />
        <div className="gallery__card bathrooms3" />
        <div className="gallery__card bathrooms4" />
        <div className="gallery__card bathrooms5" />
        <div className="gallery__card bathrooms6" />
        <div className="gallery__card bathrooms7" />
        <div className="gallery__card bathrooms8" />
      </div>
				)}
    </section>
  );
}

export default Gallery;
